import { Accordion, AccordionPanel, Box,  } from 'grommet';
import { Add, NewWindow,List, FormSchedule, History } from 'grommet-icons';
import React, { Component } from 'react'; 
import './index.css';

export interface IDashboardProps {
	//Here we pass the Props Interface
	userData : any,
	redirectTo : Function
}

export interface IDashboardState {
	//here we pass the State Interface
}

//class ComponentName Component<PropsInterface, StateInterface>
class Dashboard extends Component<IDashboardProps, IDashboardState> {
	
	constructor(props:IDashboardProps){
		super(props)

		this.state = {

		}
	}


	 

 

	// After the component did mount, we set the state.
	componentDidMount() {
	}

	render() {
		return (
			<div className="Dashboard">
				<Accordion color='dark'>
  <AccordionPanel label="Παραστατικά" className='hover' color='dark'>
    <Box pad="medium" hoverIndicator={"green"} background="light-2" onClick={()=>{this.props.redirectTo("/invoices/new")}}  alignContent='center'   flex direction='row' >
		<Add style={{marginRight : 10}}/>  Νέο Παραστατικό 
    </Box>
	<Box pad="medium" hoverIndicator={"green"} background="light-2" onClick={()=>{this.props.redirectTo("/invoices/new")}} alignContent='center'   flex direction='row' >
      <FormSchedule style={{marginRight : 10}}/>  Παραστατικά Ημέρας
    </Box>
	<Box pad="medium" hoverIndicator={"green"} background="light-2" onClick={()=>{this.props.redirectTo("/invoices/new")}} alignContent='center'   flex direction='row' >
      <History style={{marginRight : 10}}/>   Ιστορικό Παραστατικών
    </Box>
  </AccordionPanel>
   
  <AccordionPanel label="Πελάτες" className='hover'>
    <Box pad="medium" hoverIndicator={"green"} background="light-2" onClick={()=>{this.props.redirectTo("/invoices/new")}} alignContent='center'   flex direction='row' >
		 <Add style={{marginRight : 10}}/>  Νέος Πελάτης 
    </Box>
	<Box pad="medium" hoverIndicator={"green"} background="light-2" onClick={()=>{this.props.redirectTo("/invoices/new")}} alignContent='center'   flex direction='row' >
	 	<List style={{marginRight : 10}}/> Λίστα Πελατών 
    </Box>
  </AccordionPanel>
  <AccordionPanel label="Αναφορές" className='hover'   >
    <Box draggable pad="medium" hoverIndicator={"green"} background="light-2" onClick={()=>{this.props.redirectTo("/invoices/new")}} alignContent='center'   flex direction='row' >
       Νέος Πελάτης
    </Box>
	<Box pad="medium" hoverIndicator={"green"} background="light-2" onClick={()=>{this.props.redirectTo("/invoices/new")}} alignContent='center'   flex direction='row' >
        Λίστα Πελατών
    </Box>
  </AccordionPanel>
  <AccordionPanel label="Ρυθμίσεις" className='hover'>
    <Box pad="medium" hoverIndicator={"green"} background="light-2"  onClick={()=>{this.props.redirectTo("/invoices/new")}}  alignContent='center'   flex direction='row' >
       Νέος Πελάτης
    </Box>
	<Box pad="medium" hoverIndicator={"green"} background="light-2" onClick={()=>{this.props.redirectTo("/invoices/new")}}  alignContent='center'   flex direction='row' >
        Λίστα Πελατών
    </Box>
  </AccordionPanel>
</Accordion>
			</div>
		);
	}
}

export default Dashboard;